var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA4C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 6.165c0 2.767-5 9.445-5 9.445S1 8.932 1 6.165a5 5 0 1 1 10 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA4C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 7.832a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"
  })));
};
export default SvgLocation;